import type { AxiosResponse } from "axios";
import axios from "axios";
import qs from "qs";
import { interceptAndDeserializeDateTimes } from "@cpt/shared";
import { authTokenProvider } from "./auth-token-provider";

const axiosClient = axios.create({
  baseURL: process.env.API_URL,
  paramsSerializer: (params) => {
    return qs.stringify(params);
  },
});

axiosClient.interceptors.request.use(
  async (request) => {
    const accessToken = await authTokenProvider.getAccessToken();

    request.headers.set("Authorization", `Bearer ${accessToken}`);

    return request;
  },
  (error) => Promise.reject(error)
);

axiosClient.interceptors.response.use(
  (req) => Promise.resolve(req),
  async (error) => {
    if (error?.response?.status === 401) {
      const { config } = error.response;
      const accessToken = await authTokenProvider.getAccessToken(true);

      config.headers.set("Authorization", `Bearer ${accessToken}`);
      // Don't want to use the axios client otherwise it will get stuck in an infinite loop if it can't refresh the token
      return axios.request(config);
    }
    throw error;
  }
);

axiosClient.interceptors.response.use((response: AxiosResponse) => interceptAndDeserializeDateTimes(response));

export default axiosClient;
